import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Reply } from "@material-ui/icons";

const ChooseTemplateHeader = ({ category }) => {
  return (
    <header id="ChooseTemplateHeader" className="papercraft pc-pagehero">
      <div style={{ position: "absolute", top: "16px", left: "16px", zIndex: 5 }}>
        <Button
          component={Link}
          to="/"
          variant="contained"
          size="medium"
          startIcon={<Reply />}
          style={{ backgroundColor: "#1DAEE0", color: "white" }}
        >
          BACK TO HOME
        </Button>
      </div>
      <div className="pc-pagehero__inner">
        <span className="pc-eyebrow">{category || "Designer suites"}</span>
        <h1 className="pc-pagehero__title">
          Choose a <em>template</em>.
        </h1>
        <p className="pc-pagehero__lede">
          Start with one of our designer suites, or send us your own artwork —
          either way, every detail will read like a real invitation.
        </p>
      </div>
    </header>
  );
};

export default ChooseTemplateHeader;
